// 〔給存取權〕遇到「這個對象在這個節點已有指派」（409 CONFLICT detail.assignment_id）：寫出已存在的那一筆和去哪裡改（vms#32）。
import type { Assignment } from "../../lib/orgTreeApi";
import { dateStamp } from "../../lib/timefmt";

type T = (k: string, o?: Record<string, unknown>) => string;

/** 已存在那一筆的角色 + 期限；讀不到那一筆就只說在哪裡、去哪裡改。 */
export function dupAssignmentText(
  t: T,
  a: Assignment | undefined,
  where: string,
): string {
  if (!a) return t("iam.err_dup_assignment_unknown", { where });
  const role =
    a.role === "custom"
      ? (a.role_name ?? t("iam.role_custom"))
      : t("iam.role_" + a.role);
  const term = a.expires_at
    ? t("iam.dup_until", { date: dateStamp(a.expires_at) })
    : a.schedule
      ? t("iam.dup_schedule")
      : t("ot.forever");
  return t("iam.err_dup_assignment", {
    who: a.display_name,
    where,
    role,
    term,
  });
}
